import React, { useEffect, useState } from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import TicketCreateForm from '../TicketCreateForm';
import TicketUpdatesListing from '../TicketUpdatesListing';
import { TicketFormModel } from '../../models/ticket.model';
import { getTicket } from '../../services/ticket.service';
import { RED_DARK } from '../../assets/Styles';
import { TICKET_STATUS_CLOSE } from '../../assets/appConstants/constants';
import TicketClose from '../TicketCloseForm';
import { useProject } from '../../context/ProjectContext';
import { useNotification } from '../../context/NotificationContext';


interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          <Typography component={'span'}>{children}</Typography>
        </Box>
      )}
    </div>
  );
}


function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

interface TicketViewProps {
  ticket_number: string
  setBlockScreen: (p: boolean) => void
  tab?: string
  action: string
}


const TicketView: React.FC<TicketViewProps> = ({
  ticket_number,
  setBlockScreen,
  tab = '0',
  action
}
) => {

  const { selectedProject } = useProject()
  const { showNotification } = useNotification();

  const [value, setValue] = useState(parseInt(tab))

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  }

  const [currentAction, setCurrentAction] = useState<string>(action)

  const [ticketForm, setTicketForm] = useState<TicketFormModel>({
    number: ticket_number,
    title: '',
    created_by: {},
    created_date: '',
    priority: '',
    status_0: '',
    status_n: '',
    failure_date: '',
    description: '',
    element: '',
    company: '',
    area: '',
    technician: '',
    attachment: {},
    alarms: [],
    custom_fields: {},
    project_code: selectedProject
  })

  const initComponent = () => {
    setBlockScreen(true);
    Promise.all([getTicket(selectedProject, ticket_number)]).then(function (results) {
      setTicketForm(results[0]);
      setBlockScreen(false);
    }).catch((error) => {
      showNotification(error.response.data, 'error')
      setBlockScreen(false);
    });
  }

  useEffect(initComponent, []);

  const handleSelection = (key: string, value: string): void => {
    setTicketForm({
      ...ticketForm,
      [key]: value
    });
  }

  return (
    <Box sx={{ marginX: '1vw' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value}
          onChange={handleTabChange}
          variant='scrollable'
          allowScrollButtonsMobile
        >
          <Tab label='APERTURA' {...a11yProps(0)} />
          <Tab label='ACTUALIZACIONES' {...a11yProps(1)} />
          {(ticketForm.status_n && ((ticketForm.status_n as any).id === TICKET_STATUS_CLOSE.id)) &&
            (<Tab
              sx={{ color: 'black', fontWeight: 'bold' }}
              label={<Typography
                variant='inherit'
                sx={{ backgroundColor: RED_DARK, padding: '4px 12px', borderRadius: '16px' }}
                color={'white'}>Cierre
              </Typography>}
              {...a11yProps(2)}
            />)
          }
        </Tabs>
      </Box>

      <CustomTabPanel value={value} index={0}>
        <TicketCreateForm
          setBlockScreen={setBlockScreen}
          action={currentAction}
          ticketForm={ticketForm}
          handleSelection={handleSelection}
        />
      </CustomTabPanel>

      <CustomTabPanel value={value} index={1}>
        <TicketUpdatesListing
          setBlockScreen={setBlockScreen}
          action='view'
          ticket_number={ticket_number}
          ticket_status_n={ticketForm.status_n}
        />
      </CustomTabPanel>

      <CustomTabPanel value={value} index={2}>
        <TicketClose
          setBlockScreen={setBlockScreen}
          action='view'
          ticket_number={ticketForm.number}
        />
      </CustomTabPanel>

    </Box >
  );
}

export default TicketView;